import React, { useState } from "react";
import { Card, Row, Col } from "react-bootstrap";
import { FaCheck } from "react-icons/fa";
import { FaSquareCheck, FaXmark } from "react-icons/fa6";
import { MdOutlineOilBarrel, MdOutlineQuestionMark, MdOutlineSolarPower } from "react-icons/md";
import { SlEnergy } from "react-icons/sl";
import { TbFlame } from "react-icons/tb";

/**
 * SelectAnlageCard
 * 
 * This card provides the way for customer to select
 * Anlage. Card holds only main info of Anlage nothing
 * special.
 * 
 * Used in: private customer register new Anlage with QR
 * 
 * @param {param} anlage object anlage
 * @param {param} inSelected array of selected anlagen 
 * @param {param} selectHandler func handling click event
 * 
 * @returns Card
 */
const SelectAnlageCard = ({anlage, inSelected, selectHandler}) => {

    // initial vars with default values
    const [hover, setHover] = useState(false);
    const hasSecondZaehler = anlage.x_zaehlernummer_02 !== "" && anlage.x_zaehlernummer_02 !== "False"? true : false;
    var bg = "bg-secondary";
    var icon = <MdOutlineQuestionMark size={30} />;

    // change bg and icon according to energy form
    if (anlage.x_studio_field_3eKe0 === "Strom") { bg = 'bg-energo'; icon = <SlEnergy size={30} />; }
    if (anlage.x_studio_field_3eKe0 === "Gas") { bg = 'bg-info'; icon = <TbFlame size={30} />; }
    if (anlage.x_studio_field_3eKe0 === "Oil") { bg = 'bg-danger'; icon = <MdOutlineOilBarrel size={30} /> }
    if (anlage.x_studio_field_3eKe0 === "Strom-Einspeisung") { bg = 'bg-secondary'; icon = <MdOutlineSolarPower size={30} />;}

    // gui
    return (
        <Card
            key={`qranlagecard-${anlage.id}`}
            onClick={() => selectHandler(anlage)}
            onMouseEnter={() => setHover(true)} 
            onMouseLeave={() => setHover(false)}
            className={hover? "shadow-lg border-energo": ""}>
            <Card.Header className={`${bg} text-white`}>
                <div className="border border-2 rounded-circle energo-card-header-icon">
                    {icon}
                </div>
                <div className="adjust-font-on-small energo-card-header-icon-text">
                    {anlage.x_studio_field_3eKe0}
                </div>
                <div style={{ float: "right", paddingTop: "5px" }}>
                    <span style={{ fontSize: "30px", fontWeight: "300" }}>{anlage.x_studio_field_mWMGR}</span>
                </div>
                <div className="hide-on-small" style={{ display: "inline-block", float: "right", paddingTop: "16px" }}>
                    <span>Anlagennummer ENERGO: &nbsp;</span>
                </div>
            </Card.Header>
            <Card.Body>
                <Row>
                    <Col xl="8">
                        <p>Anlagenadresse &nbsp; <small className="text-muted">{anlage.x_adresse_kompakt}</small></p>
                    </Col>
                    <Col xl="4" className="text-end">
                        <FaSquareCheck hidden={inSelected === false} className="text-energo animate__animated animate__tada" size={50}/>
                    </Col>
                </Row>
                <Row>
                    <Col xl={hasSecondZaehler? "6" : "12"} className={hasSecondZaehler? "border-right": ""}>
                        <p>Zählernummer &nbsp; <small className="text-muted">{anlage.x_zaehlernummer_01}</small></p>
                        <p>Zählpunktnummer &nbsp; <small className="text-muted">{anlage.x_zaehlpunktnummer_01}</small></p>
                        <p>Lastprofil &nbsp; <small className="text-muted">{anlage.x_lastprofil_01}</small></p>
                        <p>Smartmeter &nbsp; <small>{anlage.x_is_smartmeter_01 === true? <FaCheck className="text-energo" />: <FaXmark className="text-danger" />}</small></p>
                    </Col>
                    <Col xl="6" hidden={!hasSecondZaehler}>
                        <p>Zählernummer &nbsp; <small className="text-muted">{anlage.x_zaehlernummer_02}</small></p>
                        <p>Zählpunktnummer &nbsp; <small className="text-muted">{anlage.x_zaehlpunktnummer_02}</small></p>
                        <p>Lastprofil &nbsp; <small className="text-muted">{anlage.x_lastprofil_02}</small></p>
                        <p>Smartmeter &nbsp; <small>{anlage.x_is_smartmeter_02 === true? <FaCheck className="text-energo" />: <FaXmark className="text-danger" />}</small></p>
                    </Col>
                </Row>
            </Card.Body>
        </Card>
    )
}
export default SelectAnlageCard;